import { BasicLink } from "@components/typography"
import { FlexBox } from "@components/wrapper"
import AuthServices from "@lib/api/services/auth.services"
import { getHariseninURL } from "@lib/functions"
import { useRouter } from "next/router"
import { FaPowerOff } from "react-icons/fa"

const LINKS = [
  {
    label: "Profil",
    slug: "profil",
  },
  {
    label: "Daftar Pembelian",
    slug: "order?type=learning",
  },
  {
    label: "Referral Program",
    slug: "referral",
  },
]

export const AccountPopoverContent = () => {
  const router = useRouter()
  const auth = new AuthServices()

  async function logout() {
    await auth.logout()
    router.reload()
  }
  return (
    <FlexBox
      className="bg-white p-5 rounded-lg shadow-[0_12px_32px_0px_rgba(0,0,0,0.2)] text-black"
      direction="col"
    >
      {LINKS.map((value, index) => (
        <BasicLink
          href={getHariseninURL(`/dashboard/${value.slug}`)}
          className="pb-2.5"
          key={index}
        >
          {value.label}
        </BasicLink>
      ))}

      <BasicLink href="/dashboard/progress" className="pb-2.5">
        Kelas Video Course
      </BasicLink>
      <hr className="mb-4 mt-1.5" />

      <button
        onClick={logout}
        className="text-black font-semibold flex items-center gap-2 hover:text-red"
      >
        <FaPowerOff /> Keluar
      </button>
    </FlexBox>
  )
}
